<template>
    <label for="extend-2">
        <input id="extend-2" @change="emitInput" type="checkbox" name="extend2" v-model="value" class="mr-1" />
        Extend Point 2
    </label>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    defaultValue: Boolean
});

const emit = defineEmits(['update:modelValue']);

const value = ref(props.defaultValue);

function emitInput() {
    emit('update:modelValue', value.value);
}

watch(() => props.defaultValue, (newValue) => {
    value.value = newValue;
    emit('update:modelValue', value.value);
});
</script>
